import React from 'react'
import { Button, TabContent, TabPane, Nav, NavItem, NavLink, Row, Modal, ModalHeader, ModalBody, ModalFooter, Col } from 'reactstrap'
import classnames from 'classnames'
import Payment from './Payment'
import AchPayment from './AchPayment'

class  SelectPaymentMethod extends React.Component {
    constructor(props) {
        super(props)
        this.state = {            
            activePaymentTab: '1',            
        }
    }

    ChoosePaymentTab = (tab) => {
        if (this.state.activePaymentTab !== tab) {
            this.setState({
                activePaymentTab: tab
            });
        }
    }
        
    render(){
    return(
    <Modal isOpen={this.props.isOpen} backdrop={this.props.backdrop} toggle={this.props.toggle} className={this.props.className}>
        <ModalHeader toggle={this.props.toggle}>Subscription Payment</ModalHeader>
        <ModalBody>
            <TabContent activeTab={this.state.activePaymentTab}>
                <TabPane tabId="1">
                    <Row>
                        <Col sm="12">
                            <br />
                            <Payment invoicePayment={this.props.invoicePayment} invoice={this.props.invoice} controllerid={this.props.controllerid} renewSubscriptionPlan={this.props.renewSubscriptionPlan} amount={this.props.amount} />
                        </Col>
                    </Row>
                </TabPane>
                <TabPane tabId="2">
                    <Row>
                        <Col sm="12">
                            <br />
                            <AchPayment invoicePayment={this.props.invoicePayment} invoice={this.props.invoice} controllerid={this.props.controllerid} renewSubscriptionPlan={this.props.renewSubscriptionPlan} amount={this.props.amount} />
                        </Col>
                    </Row>
                </TabPane>
            </TabContent>
        </ModalBody>
        <ModalFooter>
            <Button color="secondary" onClick={this.props.toggle}>Cancel</Button>
        </ModalFooter>
    </Modal>
    )}
}
export default SelectPaymentMethod



// WEBPACK FOOTER //
// ./src/components/ui/SelectPaymentMethod.js